import { registerPattern } from './registry';
import { chevronPattern, ripplePattern, wavesPattern } from './waves';
import {
  bricksPattern,
  domesPattern,
  facetsPattern,
  pyramidsPattern,
  ribsPattern,
  weavePattern,
} from './geometric';
import {
  cellsPattern,
  dunesPattern,
  flowPattern,
  organicPattern,
  starburstPattern,
} from './organic';
import { checkerPattern, flatPattern, gradientPattern } from './utility';
import { heightmapPattern } from './heightmap';

/**
 * Registration of the built-in pattern library.
 *
 * Importing this module once, at start-up, is what makes the patterns visible
 * to the browser, the evaluator, the presets and the export worker. To add a
 * pattern, define it and add one line here — nothing else in the app needs to
 * change.
 */

let registered = false;

export function registerBuiltinPatterns(): void {
  if (registered) return;
  registered = true;

  // Waves
  registerPattern(wavesPattern);
  registerPattern(ripplePattern);
  registerPattern(chevronPattern);

  // Lattices
  registerPattern(pyramidsPattern);
  registerPattern(ribsPattern);
  registerPattern(bricksPattern);
  registerPattern(domesPattern);
  registerPattern(weavePattern);
  registerPattern(facetsPattern);

  // Organic
  registerPattern(organicPattern);
  registerPattern(cellsPattern);
  registerPattern(dunesPattern);
  registerPattern(flowPattern);
  registerPattern(starburstPattern);

  // Images and utilities
  registerPattern(heightmapPattern);
  registerPattern(gradientPattern);
  registerPattern(checkerPattern);
  registerPattern(flatPattern);
}

export * from './registry';
export * from './helpers';
